<span ngForm #frm="ngForm">
<label *ngIf="label" [ngClass]="labelClass">{{ label }}<span *ngIf="required">*</span></label>
<mat-form-field floatLabel="never">
  <input matInput [matDatepicker]="picker" [max]="maxDate" [(ngModel)]="result" name="{{name}}"
         (ngModelChange)="onModelChanged($event)" [appCustomPatternValidator]="fieldValidationConstraints" [disabled]="disabled">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
   <mat-error *ngIf="(this.error ||  frm.controls[name]?.errors?.regexp) && frm.controls[name].invalid && (frm.controls[name].touched || frm.controls[name].dirty) ">
        <ng-container *ngIf="frm.controls[name].errors?.regexp">
            {{ frm.controls[name].errors.regexp }}
        </ng-container>
        <ng-container *ngIf="!frm.controls[name].errors?.regexp">
            {{ error }}
        </ng-container>
    </mat-error>
</mat-form-field>
</span>
